import { useTranslation } from 'react-i18next'
import { useHistory, useParams } from 'react-router'
import {
  Inline,
  Button,
  Box,
  IconArrowRight,
  IconArrowLeft,
  useResponsiveValue,
  Stack,
  useDialogController
} from '@machobear/design-system'

import ExitConfirmationModal from '@/components/exit-confirmation-modal'
import MobileBackButton from './mobile-back-button'
import { useFormContext } from '../form-context'
import { FORM_STEPS } from '../util/form-steps'
import { FormStep } from '../types'

const FormFooter = ({
  onSave,
  isLoading,
  isSubmitting,
  step
}: {
  onSave?: () => void
  isLoading?: boolean
  isSubmitting?: boolean
  step: FormStep
}) => {
  const { t } = useTranslation()
  const history = useHistory()
  const { listingId } = useParams<{ listingId: string }>()
  const { dirty } = useFormContext()
  const isMobile = useResponsiveValue()({
    mobile: true,
    tablet: false
  })

  const { visible, showModal, closeModal } = useDialogController()

  const activeStep = FORM_STEPS[step]
  const isSummaryPage = step === 'listing-summary'
  const showSaveBtn = !!onSave
  const buttonsDisabled = isLoading || isSubmitting

  const handleBack = () => {
    history.push(activeStep.backPath.replace(':listingId', listingId))
  }

  const handleClickBack = () => {
    if (dirty) return showModal()
    handleBack()
  }

  const handleModalConfirm = () => {
    handleBack()
    closeModal()
  }

  const handleOnSave = () => {
    onSave && onSave()
  }

  return (
    <>
      <ExitConfirmationModal
        visible={visible}
        closeModal={closeModal}
        handleModalConfirm={handleModalConfirm}
      />
      <MobileBackButton handleClickBack={handleClickBack} />
      {isMobile ? (
        <Box padding="gutter">
          <Stack space="medium" align="center">
            {isSummaryPage ? (
              <Button
                iconPosition="trailing"
                type="submit"
                loading={isSubmitting}
                disabled={buttonsDisabled}
              >
                {isSubmitting ? t('Publishing') : t('Publish')}
              </Button>
            ) : (
              <Button
                iconPosition="trailing"
                type="submit"
                loading={isSubmitting}
                disabled={buttonsDisabled}
              >
                {t('common.next', 'Next')}
              </Button>
            )}
            {showSaveBtn && (
              <Button
                onClick={handleOnSave}
                variant="transparent"
                type="button"
                disabled={buttonsDisabled}
              >
                {t('Save as draft', 'Save as draft')}
              </Button>
            )}
          </Stack>
        </Box>
      ) : (
        <Box display="flex" justifyContent="spaceBetween">
          <Inline space="none">
            <Button
              variant="transparent"
              icon={<IconArrowLeft />}
              onClick={handleClickBack}
              disabled={buttonsDisabled}
            >
              {t('common.back', 'Back')}
            </Button>
          </Inline>
          <Inline space="gutter" align="right">
            {showSaveBtn && (
              <Button
                onClick={handleOnSave}
                variant="transparent"
                type="button"
                disabled={buttonsDisabled}
              >
                {t('Save as draft', 'Save as draft')}
              </Button>
            )}
            {isSummaryPage ? (
              <Button
                iconPosition="trailing"
                type="submit"
                loading={isSubmitting}
                disabled={buttonsDisabled}
              >
                {isSubmitting ? t('Publishing') : t('Publish')}
              </Button>
            ) : (
              <Button
                icon={<IconArrowRight />}
                iconPosition="trailing"
                type="submit"
                loading={isSubmitting}
                disabled={buttonsDisabled}
              >
                {t('common.next', 'Next')}
              </Button>
            )}
          </Inline>
        </Box>
      )}
    </>
  )
}

export default FormFooter
